'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { SearchModal } from '@src/components/SearchModal/SearchModal';
import { useSession } from '@src/hooks/useSession';
import { defaultTopNavV6Props } from './TopNavV6.defaults';
import { TopNavV6AccountPanel } from './TopNavV6AccountPanel/TopNavV6AccountPanel';
import { TopNavV6Provider, useTopNavV6 } from './TopNavV6Context';
import { TopNavV6Desktop } from './TopNavV6Desktop/TopNavV6Desktop';
import { TopNavV6DesktopSubNav } from './TopNavV6Desktop/TopNavV6DesktopSubNav';
import { TopNavV6Mobile } from './TopNavV6Mobile/TopNavV6Mobile';
import type { TopNavV6Props } from './TopNavV6Props';
import { isActiveNavItem } from './utils';
const TopNavV6Content = props => {
  const $ = _c(30);
  const {
    navItems,
    showSearch,
    onSearchClick
  } = props;
  const {
    user
  } = useSession();
  const pathname = usePathname();
  const {
    isSearchOpen,
    setSearchOpen
  } = useTopNavV6();
  const showSearchForLoggedInUsers = showSearch && !!user;
  let t0;
  if ($[0] !== navItems || $[1] !== pathname || $[2] !== user) {
    t0 = navItems?.find(item => {
      if (item.isActive) {
        return item.navItems && item.navItems.length > 0;
      }
      const url = user && item.authenticatedHref ? item.authenticatedHref : item.href;
      return url && isActiveNavItem(url, pathname) && item.navItems && item.navItems.length > 0;
    });
    $[0] = navItems;
    $[1] = pathname;
    $[2] = user;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const activeNavItem = t0;
  let t1;
  if ($[4] !== activeNavItem?.navItems) {
    t1 = activeNavItem?.navItems ?? [];
    $[4] = activeNavItem?.navItems;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const subNavItems = t1;
  let t2;
  if ($[6] !== props || $[7] !== showSearchForLoggedInUsers) {
    t2 = <TopNavV6Mobile {...props} showSearch={showSearchForLoggedInUsers} />;
    $[6] = props;
    $[7] = showSearchForLoggedInUsers;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props) {
    t3 = <TopNavV6Desktop {...props} />;
    $[9] = props;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onSearchClick || $[12] !== showSearchForLoggedInUsers || $[13] !== subNavItems) {
    t4 = subNavItems.length > 0 && <TopNavV6DesktopSubNav items={subNavItems} showSearch={showSearchForLoggedInUsers} onSearchClick={onSearchClick} />;
    $[11] = onSearchClick;
    $[12] = showSearchForLoggedInUsers;
    $[13] = subNavItems;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="hidden lg:block">{t3}{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <div className="relative w-full">{t2}{t5}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TopNavV6AccountPanel />;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== setSearchOpen) {
    t8 = () => setSearchOpen(false);
    $[22] = setSearchOpen;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== isSearchOpen || $[25] !== t8) {
    t9 = <SearchModal isOpen={isSearchOpen} onClose={t8} />;
    $[24] = isSearchOpen;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t6 || $[28] !== t9) {
    t10 = <>{t6}{t7}{t9}</>;
    $[27] = t6;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export const TopNavV6 = t0 => {
  const $ = _c(5);
  const props = t0 === undefined ? defaultTopNavV6Props : t0;
  const {
    account
  } = props;
  let t1;
  if ($[0] !== props) {
    t1 = <TopNavV6Content {...props} />;
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== account || $[3] !== t1) {
    t2 = <TopNavV6Provider account={account}>{t1}</TopNavV6Provider>;
    $[2] = account;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};